import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import './Spiner.scss';


interface ISpinnerProps {
    pageLoader?: boolean;
    globalTransparentLoader?: boolean;
    transparentPageLoader?: boolean;
    transparentComponentLoader?: boolean;
    top?: number | string;
    left?: number | string;
}

export const Spinner = (props: ISpinnerProps): JSX.Element => {
    const { pageLoader, globalTransparentLoader, transparentPageLoader, transparentComponentLoader, top, left } = props;
    const { t } = useTranslation();

    return(
        <div className={clsx(
            transparentPageLoader && 'transparentPageLoader',
            globalTransparentLoader && 'globalTransparentLoader',
          transparentComponentLoader && 'transparentComponentLoader',
            )}
        >
            <span
                className={clsx(
                  'indicator-progress text-center d-block loader-position',
                  pageLoader && 'position-absolute fs-2',
                  globalTransparentLoader
                  || transparentPageLoader
                  || transparentComponentLoader && 'text-white'
                )}
                style={{ top, left }}
            >
                {t('GENERAL.SPINNER_TITLE')}
                <span className={clsx(
                    'spinner-border align-middle ms-2',
                        pageLoader ? 'spinner-border' : 'spinner-border-sm'
                    )}
                />
            </span>
        </div>
    );
};
